import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import GroupIcon from "../../Assets/images/svg/Icons/Group 519.svg";
import BoxHeader from "../../Components/Common/Box/Boxheader";
import { useNavigate } from "react-router-dom";
import CameraIcon from "../../Assets/images/svg/Icons/camera-logo.svg";
interface MultiStepFormProps {
  steps: string[];
  activeStep: string;
  setActiveStep: (step: string) => void;
  children: React.ReactNode;
   isEditMode?: boolean;
    onAddClick?: () => void;
}

const MultiStepForm: React.FC<MultiStepFormProps> = ({
  
  steps,
  activeStep,
  setActiveStep,
  children,
   isEditMode = false,
}) => {
   const [tab, setTab] = useState(0);
   const navigate = useNavigate()
  return (
    <Box>
      {/* Top Header Row */}
    
        {/* Left: Title */}
            <BoxHeader
      dashboard_name="Providers"
      image={CameraIcon}
      button_show={true}
      onAdd={() => navigate("/providers/add")}
      tabs={["All Providers"]}
      activeTab={tab}
      onTabChange={(newTab) => setTab(newTab)}
    />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Box>
       <Typography className="form-header">
  {isEditMode ? "Edit Providers" : "Add New Providers"}
</Typography>
          <Typography
            fontSize="18px"
            fontFamily="Segoe UI, Regular"
            color="#6E6E6E"
            mt={0.5}
          >
            {activeStep}
          </Typography>
        </Box>

        {/* Right: Step Navigation */}
        <Box display="flex" alignItems="center" gap={1}>
          {steps.map((step, index) => (
            <Box key={step} display="flex" alignItems="center">
              <Typography
                // onClick={() => setActiveStep(step)}
                sx={{
                  fontFamily: "Poppins",
                  fontSize: 13,
                  color: activeStep === step ? "#3E93E8" : "#6E6E6E",
                  cursor: "pointer",
                  fontWeight: activeStep === step ? 600 : 400,
                }}
              >
                {step}
              </Typography>

              {/* Chevron (icon) between steps */}
              {index < steps.length - 1 && (
                <Box mx={1} display="flex" alignItems="center">
                  <img src={GroupIcon} alt="icon" style={{ height: 12 }} />
                   <img src={GroupIcon} alt="icon1" style={{ height: 12 }} />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Box>

      {/* Form Content */}
      <Box>{children}</Box>
    </Box>
  );
};

export default MultiStepForm;
